import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Hassan Bello';
  data = [
    {
    image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/home_eemkbd.png',
    price: 9000
  },
  {
    image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/Rectangle_12_hygfx7.png',
    price: 9000
  },
  {
    image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/Rectangle_199_wmy18b.png',
    price: 9000
  }
]
arr1 = Array(3).fill({
  image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/home_eemkbd.png',
  price: Math.floor(Math.random() * Math.floor(1000000)),
  name: 'Standing Lamp'
})

arr2 = Array(3).fill({
  image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/Rectangle_12_hygfx7.png',
  price: Math.floor(Math.random() * Math.floor(8000000)),
  name: 'Wooden Chandelier'
})

arr3 = Array(2).fill({
  image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/Rectangle_199_wmy18b.png',
  price: Math.floor(Math.random() * Math.floor(400000)),
  name: 'Pendant Lamp'
})

arr4 = [...this.arr1, ...this.arr2,...this.arr3]
arr5 = [...Array(3).fill({
  image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/Rectangle_199_wmy18b.png',
  price: Math.floor(Math.random() * Math.floor(400000)),
  name: 'Pendant Lamp'
}),
...Array(3).fill({
  image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/Rectangle_12_hygfx7.png',
  price: Math.floor(Math.random() * Math.floor(8000000)),
  name: 'Wooden Chandelier'
}), ...Array(2).fill({
  image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602253863/home_eemkbd.png',
  price: Math.floor(Math.random() * Math.floor(1000000)),
  name: 'Standing Lamp'
})]
}
